// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useForm } from "react-hook-form";
// import { useNavigate } from "react-router-dom";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { SlArrowLeft } from "react-icons/sl";

// import LeftSection from "../../Components/Auth/LeftSection";
// import classes from "../../Components/Auth/RightSection.module.css";

// const schema = yup
//   .object()
//   .shape({
//     mobile: yup
//       .string()
//       .required("Mobile number is required!")
//       .length(10, "Mobile number must be exactly 10 digits long!"),
//   })
//   .required();

// export default function Login() {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     localStorage.removeItem("mmt_registration_data");
//     localStorage.removeItem("mmt_login_mobile");
//   }, []);

//   //console.log(process.env.REACT_APP_API_URL);
//   const { register, handleSubmit, formState, getValues, setError } = useForm({
//     resolver: yupResolver(schema),
//     mode: "onChange",
//   }); // initialise the hook

//   const { errors } = formState;

//   const onSubmit = (data) => {
//     setIsLoading(true);
//     axios
//       .post(`${process.env.REACT_APP_OTP_URL}otp/generate-otp`, data)
//       .then((res) => {
//         if (res.data.statusCode == 400) {
//           // alert("Please provide valid mobile number");
//           setError("mobile", {
//             type: "manual",
//             message:
//               "Invalid mobile number. Please provide valid mobile number",
//           });
//         } else {
//           localStorage.setItem("mmt_login_mobile", data.mobile);
//           setIsLoading(false);
//           navigate("/verify-otp");
//         }
//       })
//       .catch((err) => {
//         console.log("err", err);
//         setIsLoading(false);

//         setError("mobile", {
//           type: "manual",
//           message:
//             "Something went wrong while sending otp , please try after some time !",
//         });
//       });
//   };

//   return (
//     <>
      
//         <div className="flex flex-col md:flex-row items-center justify-center min-h-screen">
//           <div className="w-full md:w-1/2">
//             <LeftSection />
//           </div>

//           <div className="w-full md:w-1/2">
//             <span
//               onClick={() => navigate("/registration")}
//               className="float-left  text-gray-400 flex gap-2 items-center cursor-pointer"
//               // className=" top-5 left-5 md:left-10 text-gray-400 flex gap-2 items-center cursor-pointer z-10"
              
//             >
//               <SlArrowLeft className="text-xs " /> Back
//             </span>

//             <div className={`p-5 ps-20 py-16 pe-48 ${classes.RhtFormSec}`}>
//               {/* Step 1 Start*/}

//               <h2 className="text-3xl mb-3 font-semibold"> Login</h2>

//               <p className="mb-10" style={{ color: "#8692A6" }}>
//                 {" "}
//                 {/* Login */}
//               </p>

//               <div className="mb-2 w-full">
//                 <label className="w-full mb-2"> Mobile </label>
//                 <input
//                   type="number"
//                   className={`rounded-md ${classes.inputBox}`}
//                   placeholder="Please enter mobile number"
//                   {...register("mobile")}
//                 />
//               </div>
//               <span className="text-danger" style={{ fontSize: "12px" }}>
//                 {errors.mobile?.message}
//               </span>

//               {/* <input
//                 type="button"
              
//                 className={isLoading==false?`w-full main-color p-5 rounded-lg text-white mt-5 cursor-pointer`:` secondary-color w-full  p-5 rounded-lg text-white mt-5 cursor-pointer`}

//                 placeholder=""
//                 value="Login"
//                 disabled={isLoading}
//                 onClick={handleSubmit(onSubmit)}
//               /> */}

//               <button
//                 type="submit"
//                 className={`w-full ${
//                   isLoading ? "secondary-color" : "main-color"
//                 } p-5 rounded-lg text-white mt-5 cursor-pointer flex items-center justify-center`}
//                 disabled={isLoading}
//                 onClick={handleSubmit(onSubmit)}

//               >
//                 {isLoading ? (
//                   <div className="flex items-center gap-2">
//                     <svg
//                       className="animate-spin h-5 w-5 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v8H4z"
//                       ></path>
//                     </svg>
//                     <span>Loading...</span>
//                   </div>
//                 ) : (
//                   "Login"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
      
//     </>
//   );
// }



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useForm } from "react-hook-form";
// import { useNavigate } from "react-router-dom";
// import * as yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { SlArrowLeft } from "react-icons/sl";

// import LeftSection from "../../Components/Auth/LeftSection";
// import classes from "../../Components/Auth/RightSection.module.css";

// const schema = yup
//   .object()
//   .shape({
//     mobile: yup
//       .string()
//       .required("Mobile number is required!")
//       .length(10, "Mobile number must be exactly 10 digits long!"),
//   })
//   .required();

// export default function Login() {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     localStorage.removeItem("mmt_registration_data");
//     localStorage.removeItem("mmt_login_mobile");
//   }, []);

//   const { register, handleSubmit, formState, setError } = useForm({
//     resolver: yupResolver(schema),
//     mode: "onChange",
//   });

//   const { errors } = formState;

//   const onSubmit = (data) => {
//     setIsLoading(true);
//     axios
//       .post(`${process.env.REACT_APP_OTP_URL}otp/generate-otp`, data)
//       .then((res) => {
//         if (res.data.statusCode === 400) {
//           setError("mobile", {
//             type: "manual",
//             message: "Invalid mobile number. Please provide a valid number",
//           });
//         } else {
//           localStorage.setItem("mmt_login_mobile", data.mobile);
//           setIsLoading(false);
//           navigate("/verify-otp");
//         }
//       })
//       .catch(() => {
//         setIsLoading(false);
//         setError("mobile", {
//           type: "manual",
//           message:
//             "Something went wrong while sending the OTP. Please try again later!",
//         });
//       });
//   };

//   return (
//     <div className="flex flex-col md:flex-row min-h-screen">
//       {/* Left Section */}
//       <div className="hidden md:block w-1/2">
//         <LeftSection />
//       </div>

//       {/* Right Section */}
//       <div className="w-full md:w-1/2 relative bg-gray-50 flex flex-col items-center p-6">
//         {/* Back Button */}
//         <span
//           onClick={() => navigate("/registration")}
//           className="absolute top-4 left-4 md:top-6 md:left-8 text-gray-500 flex gap-2 items-center cursor-pointer"
//         >
//           <SlArrowLeft className="text-base" /> Back
//         </span>

//         {/* Login Form */}
//         <div className="w-full max-w-sm mt-16">
//           <h2 className="text-3xl font-semibold mb-4">Login</h2>
//           <p className="text-gray-500 mb-6">Please enter your details to log in</p>

//           <form
//             className="space-y-4"
//             onSubmit={(e) => {
//               e.preventDefault();
//               handleSubmit(onSubmit)();
//             }}
//           >
//             {/* Mobile Input */}
//             <div>
//               <label htmlFor="mobile" className="block text-sm mb-1">
//                 Mobile Number
//               </label>
//               <input
//                 type="text"
//                 id="mobile"
//                 name="mobile"
//                 // className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-main-color"
//                   className={`rounded-md w-full ${classes.inputBox}`}
//                 placeholder="Enter your mobile number"
//                 {...register("mobile")}
//               />
//               <p className="text-red-500 text-sm mt-1">
//                 {errors.mobile?.message}
//               </p>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               className={`w-full p-3 text-white rounded-md ${
//                 isLoading ? "secondary-color" : "main-color"
//               } flex items-center justify-center`}
//               disabled={isLoading}
//             >
//               {isLoading ? (
//                 <div className="flex items-center gap-2">
//                   <svg
//                     className="animate-spin h-5 w-5 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v8H4z"
//                     ></path>
//                   </svg>
//                   Loading...
//                 </div>
//               ) : (
//                 "Login"
//               )}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SlArrowLeft } from "react-icons/sl";

import LeftSection from "../../Components/Auth/LeftSection";
import classes from "../../Components/Auth/RightSection.module.css";
import logo from "../../Assets/MMT_Green_Black.png";

const schema = yup
  .object()
  .shape({
    mobile: yup
      .string()
      .required("Mobile number is required!")
      .length(10, "Mobile number must be exactly 10 digits long!"),
  })
  .required();

export default function Login() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem("mmt_registration_data");
    localStorage.removeItem("mmt_login_mobile");
  }, []);

  const { register, handleSubmit, formState, setError } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const { errors } = formState;

  const onSubmit = (data) => {
    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_OTP_URL}otp/generate-otp`, data)
      .then((res) => {
        if (res.data.statusCode === 400) {
          setError("mobile", {
            type: "manual",
            message: "Invalid mobile number. Please provide a valid number",
          });
        } else {
          localStorage.setItem("mmt_login_mobile", data.mobile);
          setIsLoading(false);
          navigate("/verify-otp");
        }
      })
      .catch(() => {
        setIsLoading(false);
        setError("mobile", {
          type: "manual",
          message:
            "Something went wrong while sending the OTP. Please try again later!",
        });
      });
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Left Section */}
      <div className="hidden md:block w-1/2">
        <LeftSection />
      </div>

      {/* Right Section */}
      <div className="w-full md:w-1/2 relative bg-gray-50 flex items-center justify-center p-6">
        {/* Mobile: Back Button */}
        <span
          onClick={() => navigate("/registration")}
          className="absolute top-4 left-4 md:top-6 md:left-8 text-gray-500 flex gap-2 items-center cursor-pointer"
        >
          <SlArrowLeft className="text-base" /> Back
        </span>

        {/* Content Wrapper */}
        <div className="w-full max-w-sm flex flex-col items-center justify-center min-h-screen md:min-h-[auto]">
          {/* Logo */}
          <div className="w-full max-w-sm mb-8 md:hidden  flex justify-center">
            <img
              src={logo}
              alt="Logo"
              className={classes.logoImage}
            />
          </div>

          {/* Login Form */}
          <div className="w-full">
            <h2 className="text-3xl font-semibold mb-4 text-center">Login</h2>
            <p className="text-gray-500 mb-6 text-center">
              Please enter your details to log in
            </p>

            <form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)();
              }}
            >
              {/* Mobile Input */}
              <div>
                <label htmlFor="mobile" className="block text-sm mb-1">
                  Mobile Number
                </label>
                <input
                  type="text"
                  id="mobile"
                  name="mobile"
                  className={`rounded-md w-full ${classes.inputBox}`}
                  placeholder="Enter your mobile number"
                  {...register("mobile")}
                />
                <p className="text-red-500 text-sm mt-1">
                  {errors.mobile?.message}
                </p>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className={`w-full p-3 text-white rounded-md ${
                  isLoading ? "secondary-color" : "main-color"
                } flex items-center justify-center`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                    Loading...
                  </div>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}


